import React, { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  CreateTableNew as CreateTable,
  SearchBar,
} from '../../../../../../common/APICommon';
import { LoadingSpinner } from '../../../../../../common/Loading';
import { formatDateLong } from '../../../../../../utils/textUtils';
import { getStatusConfig } from '../../../../../../utils/enums';

import { EmployeeTransactionModal } from '../../modal/EmployeeTransactionModal';
import { useEmployeeTransaction } from "../../../../../hooks/useEmployeeTransaction";
import { EmployeeTransactionViewModal } from "../../modal/EmployeeTransactionViewModal";

export const AssignedEmployeeMain = ({ user, showGeneralMessage }) => {
  const { loading, dropdownsLoading, data, options, salaryData, handleFilter } =
    useEmployeeTransaction({
      user,
      showGeneralMessage,
      employeeId:
        user?.employeePersonalInformationId ?? null
    });

  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const openModal = (item) => {
    setSelectedData(item);
    setShowModal(true);
  };

  // Simpler headers — employee doesn't need to see their own name/number columns
  const headers = ["ID", "Temp Vessel", "Assigned To", "From", "To", "Status", "Actions"];
  const accessors = ["id", "tempVesselName", "assignedToName", "effectiveFrom", "effectiveTo", "status", "actions"];

  const actions = [
    {
      name: "View",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center",
      function: (item) => openModal(item),
      visible: true,
    },
  ];

  const renderCustomCell = (row, accessor) => {
    if (accessor === 'status') {
      const config = getStatusConfig(row.status);
      return (
        <span className={`px-3 py-1 text-[11px] rounded-full font-bold border uppercase tracking-wide
          ${config.bgColor} ${config.textColor} ${config.borderColor}`}>
          {row.status}
        </span>
      );
    }
    if (accessor === 'effectiveFrom' || accessor === 'effectiveTo') return formatDateLong(row[accessor]);
    return null;
  };

  return (
    <div>
      <SearchBar handleFilter={handleFilter} />
      {/* No Create/Edit buttons — employees are view only */}
      <CreateTable
        tableName="EmployeeTransactionsTable"
        headers={headers}
        accessors={accessors}
        data={data}
        actions={actions}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
        totalItems={data?.length}
        customCellRenderer={renderCustomCell}
      />

      <EmployeeTransactionViewModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        selectedData={selectedData}
      />

      <LoadingSpinner loading={loading || dropdownsLoading} />
    </div>
  );
};